export const EXTENSION_STATUS_EP = {
  getNewList: "/manager/extension_new",
  getNewDetails: "/manager/extension_new_details",
};
